/* Vaste koopbalk (productpagina 2.0, fase P6).

   De balk voegt niets toe aan de winkelmand. Hij verstuurt het echte
   productformulier van het thema, zodat er maar een weg naar de winkelmand
   is. */
(function () {
  'use strict';

  var balk = document.querySelector('[data-ck-koopbalk]');
  if (!balk) return;

  var formulier = document.querySelector('form[data-type="add-to-cart-form"]');
  /* De knop in de vaste balk van het thema telt niet mee: die zetten we juist
     uit ten gunste van deze balk. */
  var hoofdknop = null;
  if (formulier) {
    hoofdknop = Array.prototype.filter.call(
      formulier.querySelectorAll('[data-add-to-cart]'),
      function (k) { return !k.closest('.product-form__button--fixed'); }
    )[0] || formulier.querySelector('[data-add-to-cart]');
  }
  if (!formulier || !hoofdknop) return;

  var knop = balk.querySelector('[data-ck-koopbalk-knop]');
  var maatVak = balk.querySelector('[data-ck-koopbalk-maat]');
  var prijsVak = balk.querySelector('[data-ck-koopbalk-prijs]');

  var varianten = [];
  try {
    varianten = JSON.parse(balk.querySelector('[data-ck-koopbalk-varianten]').textContent);
  } catch (e) { return; }

  var ergensVoorraad = varianten.some(function (v) { return v.op_voorraad; });
  var smal = window.matchMedia('(max-width: 749px)');

  /* Fixed werkt alleen betrouwbaar als geen enkele voorouder een transform
     heeft; een sectie van het thema kan die zo krijgen. Daarom hangt de balk
     aan de body. */
  document.body.appendChild(balk);

  /* ---- inhoud bijwerken ---- */

  function huidigeVariant() {
    var veld = formulier.querySelector('input[name="id"]');
    var id = veld ? parseInt(veld.value, 10) : 0;
    for (var i = 0; i < varianten.length; i++) {
      if (varianten[i].id === id) return varianten[i];
    }
    return null;
  }

  function maatKiezer() {
    return document.querySelector('.product-meta-selector, variant-selects');
  }

  /* Zonder gekozen maat toont de balk niet de eerste maat maar een uitnodiging.
     ck-product.js zet de klasse ck-geen-maat op de body zolang de bezoeker nog
     niets gekozen heeft (punt P3). Het veld input[name="id"] staat dan nog wel
     op de eerste variant, dus we kunnen daar niet op afgaan.

     De prijs blijft staan, want die is de reden dat iemand doorleest. Kosten de
     maten evenveel, dan gewoon dat bedrag; verschillen ze, dan "Vanaf" met de
     laagste. Bij Cosi Kids kost elke maat hetzelfde, maar dat hoeft niet zo te
     blijven. */
  function geenMaatGekozen() {
    return document.body.classList.contains('ck-geen-maat');
  }

  function prijsZonderKeuze() {
    var teKoop = varianten.filter(function (v) { return v.op_voorraad; });
    if (!teKoop.length) teKoop = varianten;
    if (!teKoop.length) return '';

    var eerste = teKoop[0].prijs;
    var gelijk = teKoop.every(function (v) { return v.prijs === eerste; });
    if (gelijk) return eerste;

    /* Verschillende prijzen: de laagste, met "Vanaf" ervoor. Vergelijken op het
       bedrag en niet op de opgemaakte tekst, want "€ 9,99" sorteert anders dan
       "€ 12,50". */
    var laagste = teKoop.reduce(function (a, b) {
      return centen(a.prijs) <= centen(b.prijs) ? a : b;
    });
    return 'Vanaf ' + laagste.prijs;
  }

  function centen(tekst) {
    var ruw = String(tekst).replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(ruw);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function bijwerken() {
    var v = huidigeVariant();

    if (geenMaatGekozen()) {
      maatVak.textContent = '';
      prijsVak.textContent = prijsZonderKeuze();
      knop.textContent = 'Kies je maat';
      knop.disabled = false;
      knop.dataset.ckActie = 'maat';
      return;
    }

    maatVak.textContent = v ? v.maat : '';
    prijsVak.textContent = v ? v.prijs : '';

    /* De tekst van de knop komt van de knop boven, zodat de taal en de staat
       van het thema leidend blijven en hier geen tweede vertaling ontstaat.

       Op een telefoon past die tekst niet: "Voeg toe aan winkelwagen" duwt de
       prijs van het scherm af, en juist maat en prijs zijn waarvoor deze balk
       bestaat. Daar staat dus een korte variant. Dat is de enige plek in dit
       project waar een knoptekst niet uit het thema komt. */
    var themaTekst = hoofdknop.querySelector('[data-add-to-cart-text]');
    themaTekst = themaTekst ? themaTekst.textContent.trim() : 'Voeg toe aan winkelwagen';
    /* Bij een pre-order (body.ck-pre-order, gezet door ck-leverbelofte.liquid)
       staat op de knop boven al "Pre-order"; dat is kort genoeg voor een
       telefoon en zegt meer dan "In winkelmand". */
    var preOrder = document.body.classList.contains('ck-pre-order');
    var kort = (smal.matches && !preOrder) ? 'In winkelmand' : themaTekst;

    if (v && v.op_voorraad && !hoofdknop.disabled) {
      knop.textContent = kort;
      knop.disabled = false;
      knop.dataset.ckActie = 'kopen';
    } else if (ergensVoorraad) {
      /* Deze maat is op, maar het product niet. Een dode knop helpt niemand;
         terug naar de maten is hier de zinnige handeling. Dit is geen
         randgeval: een deellink of een mail wijst zo naar een maat die
         intussen weg is, en er wordt een stuk per maat ingekocht. */
      knop.textContent = smal.matches ? 'Andere maat' : 'Kies een andere maat';
      knop.disabled = false;
      knop.dataset.ckActie = 'maat';
    } else {
      knop.textContent = themaTekst;
      knop.disabled = true;
      knop.dataset.ckActie = 'geen';
    }
  }

  bijwerken();
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, .product-meta-selector')) {
      setTimeout(bijwerken, 60);
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(bijwerken, 60); });
  }
  if (smal.addEventListener) smal.addEventListener('change', bijwerken);

  /* ---- klikken ---- */

  knop.addEventListener('click', function () {
    if (knop.dataset.ckActie === 'maat') {
      var kiezer = maatKiezer();
      if (kiezer) {
        kiezer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        kiezer.classList.add('ck-koopbalk__wijs-aan');
        setTimeout(function () { kiezer.classList.remove('ck-koopbalk__wijs-aan'); }, 1600);
      }
      return;
    }
    if (knop.dataset.ckActie === 'kopen') {
      if (formulier.requestSubmit) formulier.requestSubmit(hoofdknop);
      else hoofdknop.click();
    }
  });

  /* ---- wanneer zichtbaar ----

     Hier stond eerst een IntersectionObserver per element. Die bleek niet te
     deugen voor dit doel: hij vuurt alleen als een element de rand van het
     beeld kruist. Spring je in een keer voorbij de koopknop, met een
     ankerlink, een teruggezette scrollpositie of gewoon een harde veeg op een
     telefoon, dan verandert de toestand van niet-in-beeld naar niet-in-beeld
     en komt er nooit een melding. De balk bleef dan onderaan de pagina weg.

     Nu wordt de stand gewoon uit de posities gelezen, afgeknepen op een
     animatieframe. Dat kan niet achterlopen. */

  var look = document.querySelector('.ck-look-compleet');
  var nuAan = null;
  var gepland = false;
  var vorigeVrij = null;
  var vorigeVipOmhoog = null;

  function inBeeld(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    /* Hoogte nul telt niet. Een merk zonder bundels levert een leeg look-blok
       op, en dat mag de balk niet de hele pagina lang wegdrukken. */
    if (r.height === 0) return false;
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  /* Ligt er iets over de balk heen?

     Dit ging op een echte telefoon mis. De cookiebanner van Shopify staat op
     z-index 2000000 en de popup van Klaviyo daar nog overheen; de balk was
     dan wel zichtbaar maar de tik kwam nooit bij de knop aan. Een knop die er
     wel staat en niets doet is erger dan geen knop, dus de balk blijft weg
     zolang er iets overheen ligt.

     Erboven klimmen is geen optie: toestemming voor cookies hoort bovenaan te
     liggen, en een popup van de nieuwsbrief net zo goed.

     Twee dingen om te onthouden. De cookiebanner heeft shopify-pc__banner als
     ID en niet als klasse. En Klaviyo gebruikt NIET overflow-hidden zoals het
     thema, maar een eigen klasse. Komt er ooit een app bij die het scherm
     afdekt, dan hoort die hier ook in de lijst. */
  function ietsErOverheen() {
    var b = document.body.classList;
    if (b.contains('overflow-hidden')) return true;                /* winkelmand, menu, modals van het thema */
    if (b.contains('klaviyo-prevent-body-scrolling')) return true; /* popup van Klaviyo */
    if (document.querySelector('dialog[open]')) return true;       /* de maattabel, en andere dialogs */
    var banner = document.querySelector('#shopify-pc__banner, [class*="shopify-pc__banner"]');
    if (banner && banner.getBoundingClientRect().height > 0) return true;
    return false;
  }

  /* De previewbalk van Shopify staat onderin en valt precies over de koopbalk,
     zodat een tik in een preview nooit aankomt. Die balk bestaat alleen zolang
     je een ongepubliceerd thema bekijkt en op de winkel zelf dus niet, maar
     zonder deze regel is de koopbalk in een preview niet te testen. De balk
     schuift er daarom bovenop. */
  function previewbalkHoogte() {
    var pb = document.querySelector('#PBarNextFrameWrapper');
    if (!pb) return 0;
    var r = pb.getBoundingClientRect();
    return r.height > 0 && r.bottom >= window.innerHeight - 2 ? Math.round(r.height) : 0;
  }

  var galerij = document.querySelector('.product__media-wrapper');

  function meten() {
    gepland = false;

    /* WANNEER DE BALK VERSCHIJNT (besluit B6, Mobiel 2.1 fase M4).

       Eerst: pas als de koopknop naar boven uit beeld was. Op een telefoon
       stond die knop op 1.304 px, dus de bezoeker moest twee schermen door
       voordat er iets te kopen viel, en de balk kwam daar nog achteraan
       (punt P1 uit de review van 7 september).

       Nu: zodra de galerij naar boven uit beeld is. Dat is het moment waarop
       de foto zijn werk gedaan heeft en de bezoeker aan het lezen is. De knop
       zelf mag dan nog onder de vouw staan.

       De knop niet in beeld blijft de tweede voorwaarde: staat hij er wel,
       dan zijn er twee koopknoppen tegelijk en dat is er een te veel. Zonder
       galerij (mocht die er ooit niet zijn) valt hij terug op het oude
       gedrag. */
    var knopVak = hoofdknop.getBoundingClientRect();
    var knopInBeeld = knopVak.bottom > 0 && knopVak.top < window.innerHeight;
    var voorbij = galerij
      ? galerij.getBoundingClientRect().bottom < 0
      : knopVak.bottom < 0;

    var aan = voorbij && !knopInBeeld &&
      !inBeeld(look) &&        /* twee koopknoppen tegelijk is er een te veel */
      !ietsErOverheen();

    var pb = previewbalkHoogte();
    balk.style.bottom = pb ? pb + 'px' : '';

    /* Alleen schrijven als er echt iets verandert. Deze functie zet zelf een
       klasse op de body en wordt door een MutationObserver op diezelfde body
       aangeroepen; zonder deze wacht roept hij zichzelf aan de gang. */
    if (aan !== nuAan) {
      nuAan = aan;
      balk.hidden = !aan;
      document.body.classList.toggle('ck-koopbalk-aan', aan);
    }

    /* VIP-knop van Smile opzij voor de koopknop (2026-10-18). Sinds de regel
       uit B1 eruit is staat de knop weer op de productpagina, en dan ligt hij
       rechtsonder over de koopknop zodra die onderin beeld staat; bij korte
       producten al bij het laden. Zolang dat zo is schuift hij er net boven,
       met 8 px lucht, op dezelfde manier als boven de koopbalk. */
    var vipOmhoog = 0;
    if (!aan && knopVak.top < window.innerHeight && knopVak.bottom > window.innerHeight - 100) {
      vipOmhoog = Math.max(0, Math.round(window.innerHeight - knopVak.top - 8));
    }
    if (vipOmhoog !== vorigeVipOmhoog) {
      vorigeVipOmhoog = vipOmhoog;
      document.documentElement.style.setProperty('--ck-vip-omhoog', vipOmhoog + 'px');
      document.body.classList.toggle('ck-vip-omhoog', vipOmhoog > 0);
    }

    /* Hoeveel ruimte de balk onderin inneemt, zodat de VIP-knop van Smile er
       net boven komt. Een vast getal ging mis zodra de balk zelf omhoog schoof
       voor de previewbalk: dan kwam die knop juist over de koopknop te liggen.

       Uitgerekend uit de hoogte en niet uit getBoundingClientRect(). Die telt
       namelijk de transform mee waarmee de balk bij het verschijnen omhoog
       schuift, en op dat moment leek er precies een balkhoogte minder ruimte
       nodig. offsetHeight kent die animatie niet. */
    if (aan) {
      var vrij = pb + balk.offsetHeight + 12;
      if (vrij !== vorigeVrij) {
        vorigeVrij = vrij;
        document.documentElement.style.setProperty('--ck-koopbalk-vrij', vrij + 'px');
      }
    }
  }

  function plannen() {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(meten);
  }

  window.addEventListener('scroll', plannen, { passive: true });
  window.addEventListener('resize', plannen, { passive: true });
  /* Ook na een klik opnieuw kijken: het wegklikken van de cookiebanner of van
     een popup is een klik, en zonder deze regel komt de balk pas terug zodra
     de bezoeker toevallig weer scrolt. */
  document.addEventListener('click', plannen, true);
  new MutationObserver(plannen).observe(document.body, {
    attributes: true, attributeFilter: ['class'], childList: true
  });

  /* De balk verandert na het tonen nog van maat: het lettertype komt binnen,
     op smalle schermen vervallen de foto en de titel, en de previewbalk laadt
     laat. */
  if (window.ResizeObserver) new ResizeObserver(plannen).observe(balk);
  [400, 1500, 4000].forEach(function (ms) { setTimeout(plannen, ms); });

  meten();
})();
